<template>
  <div class="orders">
    <div>
      <van-nav-bar title="订单确认" @click-left="onClickLeft" left-arrow />
    </div>
    <div class="content">
      <ul>
        <li v-for="(item, index) in productList" :key="index">
          <div class="content_head pay-radius">
            <van-row>
              <van-col>
                <img :src="item.mainPictureUrl" alt />
              </van-col>
              <van-col class="head_title" span="17">
                {{ item.title }}
                <div
                  v-for="(items, i) in item.productSpecificationsVos"
                  :key="i"
                >
                  {{ items.productAttributeName }} {{ items.val }}
                </div>
                <div class="head_price">
                  <div class="flex-price">
                    <div class="head-beforeMoney">
                      ￥{{ item.price }}
                      <span class="price-beforeMoney"
                        >￥{{ item.marketPrice }}</span
                      >
                    </div>
                    <div class="price-num">X{{ item.quantity }}</div>
                  </div>
                </div>
              </van-col>
            </van-row>
          </div>
          <div class="power_content pay-allradius">
            <div class="power_show">
              <div>
                服务方式
                <span class="from-store">到店自提</span>
              </div>
            </div>
            <div class="power_detail">
              <p>自提门店详细信息</p>
              <p>门店名称：{{ item.storeSelfMentionName }}</p>

              <div v-if="businessTimeShow" class="power_detail_div">
                <van-row>
                  <van-col class="shop-time-title">店铺营业时间:</van-col>
                  <van-col
                    span="17"
                    class="shop-time"
                    v-html="showBuinessTime(item.businessTime)"
                  ></van-col>
                </van-row>
              </div>

              <p class="store-address">店址:{{ item.address }}</p>
              <p>
                店铺服务电话:
                <span v-for="(it, s) in phoneList" :key="s"
                  >{{ it }} &emsp;</span
                >
              </p>
            </div>
          </div>
        </li>
      </ul>
      <div class="pay_remark pay-allradius">
        <van-field
          v-model="text"
          @input="payNote"
          label="订单备注"
          placeholder="选填"
        />
      </div>
      <div
        v-if="payList.name && payList.couponVos.length > 0"
        class="pay_num pay-cardradius"
      >
        <choice-card
          @getCouponArray="getCouponArray"
          :payList="payList"
          :useCoupon="useCoupon"
          @againSelect="againSelect"
          @nameArray="nameArray"
        />
      </div>
      <div class="pay_num">
        <div class="pay_title">商品金额</div>
        <div
          class="pay_now pay_title"
          style="color: black; padding-bottom: 7px"
        >
          ￥{{ payList.totalAmount }}
        </div>
      </div>
      <gold-coins
        class="pay_num"
        ref="goldCoins"
        :payList="payList"
        @useGoldClick="useGoldClick"
        @zeroGoldClick="zeroGoldClick"
      />
    </div>
    <div class="onsubmit">
      <van-submit-bar
        class="submit_main"
        :label="getAge"
        @submit="onSubmit"
        :disabled="hasSubmit"
        button-color="#ff3300"
        :price="preferentialPrice"
        button-text="提交订单"
      />
    </div>
    <toast-show :showMessage="showMessage" :showToast="showToast" />
  </div>
</template>

<script>
import toastShow from '@/components/content/toastShow'
import { PRODUCT_ENQUIRY } from '@/config/platformtype'
import { FRONTEND_HOST } from '@/config/domainnameconstant'
import getIsWx from '@/mixins/getIsWx'
import choiceCard from '@/components/content/choiceCard'
import goldCoins from '@/components/content/goldCoins'
import Cookies from 'js-cookie'
import { submissionOrdersV2, settlement, toPayV2 } from '@/api/productsDetaile'
export default {
  mixins: [getIsWx],
  data() {
    return {
      nameShow: true,
      hasResult: true,
      getObj: {},
      getCardsArray: [],
      useCoupon: true,
      hasSubmit: false,
      businessTimeShow: false,
      skuArrs: [],
      arrVal: '',
      getArrId: [],
      payList: {},
      productList: [],
      preferentialPrice: 0,
      phoneList: [],
      productListItem: [],
      payTime: [],
      showMessage: '',
      showToast: false,
      texts: '',
      age: 0,
      text: '',
      pricehead: {
        img: '',
        title: '',
        isSelect: '',
        beforeMoney: '',
        nowPrice: '',
        isNumbers: '',
        toPromise: '随时退/过期自动退',
      },
    }
  },
  components: {
    toastShow,
    choiceCard,
    goldCoins,
  },
  computed: {
    getAge() {
      return '共' + this.age + '件,合计'
    },
  },
  created() {
    this.getArrId = JSON.parse(this.$route.query.items)
    this.getObj = {
      cartItemIds: this.getArrId,
      useCoupon: this.useCoupon,
      useGold: true,
      useGoldCount: 0,
    }
    this.getConfirmation(this.getObj)
    window.document.title = '订单确认'
  },
  mounted() {
    if (this.$getIsApp()) {
      this.$callApp('iOS', 'HiddenTabBarMethod', '')
    }
  },
  methods: {
    // 金币清零
    zeroGoldClick() {
      this.getObj.useGoldCount = 0
      this.getConfirmation(this.getObj)
    },
    // 金币弹窗关闭使用金币
    useGoldClick(val) {
      this.getObj.useGoldCount = Number(val)
      this.getConfirmation(this.getObj)
    },
    nameArray(nameArray) {
      this.nameShow = nameArray
    },
    againSelect() {
      // delete this.getObj.useGoldCount
      this.getObj.useGoldCount = 0
      this.getConfirmation(this.getObj)
    },
    getCouponArray(val) {
      console.log('getCouponArray', val)
      this.getCardsArray = val
      if (val.length === 0) {
        this.getObj.couponHistoryIds = []
        // delete this.getObj.useGoldCount
        this.getObj.useGoldCount = 0
        this.getConfirmation(this.getObj)
        this.hasResult = false
      } else {
        // delete this.getObj.useGoldCount
        this.getObj.useGoldCount = 0
        this.getObj.couponHistoryIds = val
        this.getConfirmation(this.getObj)
      }
      // 控制金币子组件勾选取消
      this.$refs.goldCoins.changeGoldChecked()
    },
    // 营业时间
    showBuinessTime(timestr) {
      // "周六,周日#24小时营业;周四,周五#00:01,00:28;周六#24小时营业" 这是时间的demo
      // timestr = "周六,周日#24小时营业;周四,周五#00:01,00:28;周六#24小时营业"
      let txt = ''
      timestr.split(';').forEach((value) => {
        value.split('#').forEach((ele) => {
          if (ele.includes(':')) {
            txt += ele.replace(',', '-') // 如果是逗号,那就是时间段,替换成-号
          } else {
            txt += ele
          }
          txt += ' '
        })
        txt += '<br>'
      })
      return txt
    },
    // 订单备注
    payNote(val) {
      this.text = val
    },
    unique(arr) {
      const res = new Map()
      return arr.filter((a) => !res.has(a) && res.set(a, 1))
    },
    // 去结算接口
    getConfirmation(getObj) {
      this.hasSubmit = true
      const loading = this.$toast.loading({
        overlay: true,
        forbidClick: true,
        duration: 0,
        message: '请稍等...',
      })
      settlement(getObj).then((res) => {
        if (res.data.code === 200) {
          loading.clear()
          this.hasSubmit = false
          // 拿到默认选择优惠劵的名字
          if (res.data.data.couponVos && this.hasResult && this.nameShow) {
            const cardItemName = []
            res.data.data.couponVos.forEach((item) => {
              if (item.choose) {
                cardItemName.push(item.couponName)
              }
            })
            res.data.data.cardItemName = cardItemName.toString()
            console.log(
              'res.data.data.cardItemName111',
              res.data.data.cardItemName
            )
          }
          // 默认拿到优惠劵组合
          if (res.data.data.couponCombinations && this.hasResult) {
            this.getCardsArray = []
            res.data.data.couponCombinations.forEach((el) => {
              console.log('ell`````````', el)
              el.forEach((item) => {
                console.log('``````item', item)
                if (item.choose) {
                  this.getCardsArray.push(item.id)
                  console.log(
                    'this.getCardsArraythis.getCardsArray',
                    this.getCardsArray
                  )
                }
              })
            })
            this.getCardsArray = this.unique(this.getCardsArray)
          }
          this.payList = res.data.data
          this.payList.name = 'orderCart'
          this.productList = this.payList.confirmOrderItemVo.confirmProductVos
          console.log('yes完成', this.payList)
          this.age = 0
          for (const index in this.productList) {
            console.log('index', index, 'array', this.productList[index])
            // 合计循环
            this.age += this.productList[index].quantity
            // 自提电话
            this.phoneList = this.productList[index].telephone.split(',')
            // 营业时间
            if (this.productList[index].businessTime) {
              this.businessTimeShow = true
            }
          }
          console.log('confirmProductVos是', this.productList)
          this.arrVal = []
          this.skuArrs = []
          this.arrVal = this.productList.map((el, i) => {
            console.log('上帝啊', el)
            const objs = {}
            objs.productSkuId = el.id
            objs.storeSelfMentionId = el.storeSelfMentionId
            objs.quantity = el.quantity
            this.skuArrs.push(objs)
            return this.skuArrs
          })
          console.log(' this.skuArrs', this.skuArrs)
          // 实付金额
          this.preferentialPrice = this.payList.payAmount * 100
        } else {
          loading.clear()
        }
      })
      // .finally(() => loading.clear())
    },
    // 提交订单接口
    onSubmit() {
      const loading = this.$toast.loading({
        overlay: true,
        forbidClick: true,
        duration: 0,
        message: '下单中...',
      })
      submissionOrdersV2({
        platformType: PRODUCT_ENQUIRY,
        submitProductVos: this.skuArrs,
        storeId: this.$route.query.storeId,
        note: this.text,
        deliveryMethod: 0,
        useCoupon: this.useCoupon,
        couponHistoryIds: this.getCardsArray,
        useGold: true,
        useGoldCount: this.getObj.useGoldCount,
      })
        .then((res) => {
          if (res.data.code === 200) {
            loading.clear()
            const Data = res.data.data
            console.log('Data', Data)
            Data.deliveryMethod = 0
            if (Data.certificationType === 1) {
              this.$router.push({
                path: '/themepage/PaymentTransition',
                query: Data,
              })
              return
            }
            let toPayRequestVo = {}
            if (Data.certificationType === 0) {
              toPayRequestVo = {
                orderId: Data.orderId,
                payType: '5',
              }
            }

            console.log('toPayRequestVo', toPayRequestVo)
            toPayV2(toPayRequestVo)
              .then((res) => {
                if (res.data.code === 200) {
                  console.log('去支付成功', res.data.data)
                  let payData = {
                    payData: res.data.data.payData,
                    orderId: res.data.data.orderId,
                    certificationType: res.data.data.certificationType,
                    payType: res.data.data.payType,
                  }
                  if (res.data.data.needPay) {
                    if (this.$isWeixin()) {
                      const successReturnUrl = `${FRONTEND_HOST}/themepage/success?id=${payData.orderId}`
                      const failReturnUrl = `${FRONTEND_HOST}/themepage/error?id=${payData.orderId}`
                      window.location.href =
                        payData.payData +
                        `&successReturnUrl=${encodeURIComponent(
                          successReturnUrl
                        )}&failReturnUrl=${encodeURIComponent(failReturnUrl)}`
                    } else {
                      const analysis = JSON.parse(payData.payData)
                      let token = ''
                      if (Cookies.get('token')) {
                        token = Cookies.get('token')
                        const successReturnUrl = `${FRONTEND_HOST}/themepage/success?id=${payData.orderId}&token=${token}`
                        window.location.href =
                          analysis.MwebUrl +
                          `&redirect_url=${encodeURIComponent(
                            successReturnUrl
                          )}`
                      } else {
                        const successReturnUrl = `${FRONTEND_HOST}/themepage/success?id=${payData.orderId}`
                        window.location.href =
                          analysis.MwebUrl +
                          `&redirect_url=${encodeURIComponent(
                            successReturnUrl
                          )}`
                      }
                    }
                  } else {
                    window.location.href = `${FRONTEND_HOST}/themepage/success?id=${
                      payData.orderId
                    }&zero=${0}`
                  }
                }
              })
              .catch((error) => {
                console.log('error:', error)
                this.showMessage = error.msg
                this.showToast = true
                setTimeout(() => {
                  this.showToast = false
                }, 3000)
              })
          } else {
            loading.clear()
          }
        })
        // .finally(() => loading.clear())
        .catch((error) => {
          console.log('error:', error)
          this.showMessage = '发起支付失败，请您尝试再次提交订单'
          this.showToast = true
          setTimeout(() => {
            this.showToast = false
          }, 3000)
        })
    },
    onClickLeft() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.back(-1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-icon {
  color: black;
  font-size: 18px;
}

.orders {
  width: 100%;
  height: 100%;
  background-color: #eee;
  padding-bottom: 1px;
  margin-bottom: 120px;
}
//navbar
.van-nav-bar {
  height: 44.5px;
  line-height: 44.5px;
  /deep/.van-nav-bar__text {
    font-size: 18px;
    color: black;
  }
  .van-nav-bar__arrow {
    font-size: 18px;
  }
}
//content_head
.content_head {
  background-color: #fff;
  border-bottom: 1px solid #eee;
  padding: 15px 15px 10px 15px;
  img {
    margin-right: 10px;
    width: 79px;
    height: 79px;
    border-radius: 7.5px;
  }
  .head_title {
    font-size: 15px;
    div {
      color: #969799;
      margin-top: 7.5px;
      font-size: 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .head_price {
    .flex-price {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      width: 220px;
    }
    font-size: 12px;
    color: #969799;
    .price-num {
      padding-top: 6px;
    }
    .head-beforeMoney {
      font-size: 15px;
      color: black;

      .price-beforeMoney {
        font-size: 12px;
        text-decoration: line-through;
        color: #969799;
      }
    }
  }
  .head_tag {
    .van-tag--default {
      padding: 2.5px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
}
// content
.content {
  width: 350px;
  margin: 10px 12.5px 10px;
  border-radius: 12.5px;
  overflow: hidden;
  //购买数量
  .pay-radius {
    border-radius: 0 0 12.5px 12.5px;
  }
  /deep/.pay-allradius {
    border-radius: 12.5px;
  }
  .pay-cardradius {
    border-radius: 12.5px 12.5px 0 0;
  }
  /deep/.pay_num {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 5px;
    .pay_title {
      font-size: 15px;
    }
    .pay_now {
      color: #c30d23;
    }
    //input输入
    .van-stepper__minus {
      height: 28px;
      width: 28px;
    }
    .van-stepper__input {
      height: 28px;
      margin: 0;
      width: 28px;
      font-size: 12px;
    }
    .van-stepper__plus {
      height: 28px;
      width: 28px;
    }
  }
  //订单备注
  /deep/.pay_remark {
    border-radius: 12.5px;
    margin: 11px 0;
    .van-cell {
      border-radius: 8px;
      padding-left: 10px;
    }
    .van-field__control {
      background-color: #efefef;
      border-radius: 5px;
      font-size: 12px;
    }
    .van-field__body {
      padding-left: 6px;
    }
    .van-cell__title {
      width: auto;
    }
  }
  //下拉菜单和服务信息
  .power_content {
    margin-top: 11px;
    background-color: #fff;
    padding-top: 11px;
    /deep/ .power_show {
      position: relative;
      .from-store {
        position: absolute;
        right: 0;
        margin-right: 15px;
      }
      div {
        line-height: 20px;
      }
      padding: 0px 10px;
      font-size: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    //服务信息
    .power_detail {
      padding: 10px 10px;
      font-size: 12px;
      p {
        padding: 3px 0;
      }
      p:nth-of-type(1) {
        color: #969799;
      }
      .store-address {
        padding-left: 32px;
        text-indent: -32px;
        letter-spacing: 1.5px;
      }
      .power_detail_div {
        .shop-time-title {
          color: #333;
          padding-bottom: 5px;
        }
        .shop-time {
          padding: 0px 5px 7.5px;
        }
      }
      .store-address {
        padding-left: 32px;
        text-indent: -32px;
        letter-spacing: 1.5px;
      }
    }
  }
}
//onsubmit提交
.onsubmit {
  .submit_main {
    padding: 5px 0px;
    line-height: 40px;
    .van-submit-bar__bar {
      height: 40px;
    }
    .van-submit-bar__button {
      width: 150px;
      height: 40px;
    }
    .van-submit-bar__text {
      padding-right: 15px;
      font-size: 12px;
      color: black;
    }
    .van-submit-bar__price {
      margin-left: 5px;
      font-size: 18px;
      color: #c30d23;
    }
    .van-button--normal {
      font-size: 15px;
    }
  }
}
//vant-load加载
/deep/ .vant-load {
  .van-loading__text {
    color: #1989fa;
  }
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 11111;
}
</style>
